import {
  MenuItem,
  Select,
  Stack,
  TextField,
  Autocomplete,
  Grid,
} from "@mui/material"
import { useEffect, useState } from "react"
import Modal from "../ui/Modal"
import FormItem from "../ui/FormItem"
import { accountTransfer, searchAccountDepositor } from "../../api"
import { useSnackbar } from "notistack"

const TransferBalance = ({ ...props }) => {
  const { enqueueSnackbar } = useSnackbar()
  const [loading, setLoading] = useState(false)

  const [transferBalance, setTransferBalance] = useState({
    currency: "INR",
    amount: 0,
  })
  const [inputValue1, setInputValue1] = useState()
  const [inputValue2, setInputValue2] = useState()

  const [students, setStudents] = useState([])
  const handleChange = (event) => {
    const { name, value } = event.target
    setTransferBalance({
      ...transferBalance,
      [name]: value,
    })
  }

  const handleSubmit = () => {
    setLoading(true)

    accountTransfer(transferBalance)
      .then((res) => {
        enqueueSnackbar("Balance transferred.", { variant: "success" })
        props.refresh()
        props.close()
      })
      .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
      .finally(() => setLoading(false))
  }

  const [searching, setSearching] = useState(false)

  const searchStudents = (value) => {
    searchAccountDepositor({
      keyword: value,
    })
      .then((res) => {
        console.log(res)
        setStudents(res.data.rows.map((r) => ({ ...r, label: r.name })))
      })
      .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
      .finally(() => setSearching(false))
  }

  useEffect(() => {}, [])

  return (
    <Modal
      {...props}
      title="Transfer Balance"
      actionText={"Add"}
      action={handleSubmit}
      loading={loading}
    >
      <Stack>
        <FormItem label="From Account">
          <Autocomplete
            loading={searching}
            name="fromAccount"
            value={transferBalance.fromAccount}
            onChange={(_, newValue) => {
              setTransferBalance({
                ...transferBalance,
                fromAccount: newValue?.id,
              })
            }}
            inputValue={inputValue1}
            onInputChange={(_, newInputValue) => {
              console.log(newInputValue)
              if (newInputValue) setInputValue1(newInputValue)
              searchStudents(newInputValue)
            }}
            getOptionLabel={(option) => option.accountName}
            options={students}
            renderInput={(params) => <TextField {...params} />}
          />
        </FormItem>

        <FormItem label="To Account">
          <Autocomplete
            loading={searching}
            name="toAccount"
            value={transferBalance.toAccount}
            onChange={(_, newValue) => {
              setTransferBalance({
                ...transferBalance,
                toAccount: newValue?.id,
              })
            }}
            inputValue={inputValue2}
            onInputChange={(_, newInputValue) => {
              if (newInputValue) setInputValue2(newInputValue)
              searchStudents(newInputValue)
            }}
            getOptionLabel={(option) => option.accountName}
            options={students}
            renderInput={(params) => <TextField {...params} />}
          />
        </FormItem>
        <Stack direction={"row"} spacing={2} alignItems="center">
          <FormItem label="Amount">
            <Grid container spacing={1} width={"100% "}>
              <Grid item xs={3}>
                <Select
                  name="currency"
                  value={transferBalance.currency}
                  onChange={handleChange}
                  fullWidth
                >
                  <MenuItem value="INR">₹</MenuItem>
                  <MenuItem value="USD">$</MenuItem>
                </Select>
              </Grid>
              <Grid item xs={9}>
                <TextField
                  name="amount"
                  value={transferBalance.amount}
                  onChange={handleChange}
                  fullWidth
                  type={"number"}
                />
              </Grid>
            </Grid>
          </FormItem>
        </Stack>
      </Stack>
    </Modal>
  )
}

export default TransferBalance
